import { Program, ProgramId, Programs } from '.';

const DefaultProgramId: ProgramId = 'us-expedia';

type TGetProgramOptions = {
  programId: ProgramId;
};

function getProgram({ programId }: TGetProgramOptions): Program {
  return Programs?.[programId] ?? Programs?.[DefaultProgramId];
}

export { DefaultProgramId, getProgram };
